export default defineNuxtRouteMiddleware(async () => {
  const { isMaintainceMode } = useEnvironment()
  if (isMaintainceMode.value === true) {
    throw showError({
      statusCode: 503,
      statusMessage: 'Agent Portal Notice',
      message:
        'We’re currently carrying out further improvements to the Agent Portal as part of our ongoing innovations. <br> <br> This means the portal is temporarily running updates, which will complete within the next 2 to 3 hours to bring even greater efficiency to your case management. <br> <br> Please try again shortly. ',
    })
  }
})
